import { render, staticRenderFns } from "./FreshdeskTicketAdd.vue?vue&type=template&id=dad6a442&scoped=true&"
import script from "./FreshdeskTicketAdd.vue?vue&type=script&lang=js&"
export * from "./FreshdeskTicketAdd.vue?vue&type=script&lang=js&"
import style0 from "./FreshdeskTicketAdd.vue?vue&type=style&index=0&id=dad6a442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad6a442",
  null
  
)

export default component.exports